import {
  QUESTIONNAIRE_QUESTIONS_LOADING,
  QUESTIONNAIRE_QUESTIONS_SUCCESS,
  QUESTIONNAIRE_QUESTIONS_ERROR
} from '../actions/questionnaire';

const initialState = {
  questions: [],
  loading: false,
  error: null,
};

export default function questionnaireReducer(state = initialState, action) {
  switch (action.type) {
    case QUESTIONNAIRE_QUESTIONS_LOADING:
      return { ...state, loading: true, error: null };
    case QUESTIONNAIRE_QUESTIONS_SUCCESS:
      return { ...state, loading: false, questions: action.payload, error: null };
    case QUESTIONNAIRE_QUESTIONS_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
} 